import React from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBridge, faCircleCheck, faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import { ui } from "./psShared";

export default function PSVision() {
  // FIX: was `state.authReducer` — every other PehchaanSetu screen reads
  // `state.authState`, so this was always undefined and userName/userCode
  // silently never rendered.
  const authState = useSelector((state) => state.authState);
  const userName = authState?.user?.name;

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <div className={`${ui.card} flex flex-col items-center gap-5 p-6 md:flex-row md:items-start`}>
        <img
          src="/assets/imgFounders2.webp"
          alt="Babita Sinha, Co-founder"
          className="h-24 w-24 shrink-0 rounded-full ring-2 ring-fuchsia-400/40 lg:h-28 lg:w-28"
        />
        <div className="text-center md:text-left">
          <FontAwesomeIcon icon={faQuoteLeft} className="text-fuchsia-400/50 text-lg" />
          <blockquote className="mt-1 text-[13px] italic leading-relaxed text-white/75 lg:text-base">
            PehchaanSetu is more than an app — it's a bridge to hidden opportunities for local 
            heroes. Like LinkedIn for professionals and BNI for local referrals, but built for
            local like neighbourhood, villages: simple profiles, quick jobs, trusted chapters, and income 
            tracking that shows real growth. Together, we'll turn isolated talents into connected communities,
            empowering every youth, women, farmer, artisan, and blue-collars to thrive without leaving home.
          </blockquote>
          <footer className="mt-3 text-[11px] font-semibold text-fuchsia-300 lg:text-sm">
            Babita Sinha, Co-founder, Think5Whys — Transformation-as-a-Platform
          </footer>
        </div>
      </div>

      {userName && (
        <p className="mt-4 text-center text-[12px] text-white lg:text-sm">
          Welcome, {userName} — here's why we built this for you.
        </p>
      )}

      <div className="mt-6 space-y-6">
        <Section title="Why This Works for Urabl and Rural India also for Youth specially Women" icon={faBridge}>
          <p className="text-[12px] leading-relaxed text-white lg:text-sm">
            In urban local area, villages, etc like minded connections mean everything — but they're hard to find. 
            PehchaanSetu changes that with easy tools for everyone, even if you're new to phones. No big city
            needed; just local jobs, groups, and growth you can see.
          </p>
        </Section>

        <Section title="Like LinkedIn & BNI, But Yours">
          <ul className="space-y-2 text-[12px] text-white lg:text-sm">
            <ListItem>
              <strong className="text-white/85">Profiles &amp; Opportunities</strong> — show your skills
              (wiring, pickle-making and so on) and grab nearby work, fast, like LinkedIn jobs but for your neighbourhhod 
              and village.
            </ListItem>
            <ListItem>
              <strong className="text-white/85">Circles &amp; Chapters</strong> — join youth, woemn, farmer groups or
              students meet, electrician meets, share referrals like BNI, and build trust right at home.
            </ListItem>
            <ListItem>
              <strong className="text-white/85">Messages &amp; Invites</strong> — We leave it on you for your preferred 
              chat / IM like WhatsApp etc for endorsements, and grow your name without travel.
            </ListItem>
            <ListItem>
              <strong className="text-white/85">Income Dashboard</strong> — see earnings in clear charts
              and motivate yourself / chapters / circles with real numbers.
            </ListItem>
          </ul>
        </Section>

        <Section title="Real Stories from Similar Networks">
          <ul className="space-y-2 text-[12px] text-white lg:text-sm">
            <ListItem>Farmers using e-NAM sell crops to bigger buyers, earning 20–50% more — no middlemen.</ListItem>
            <ListItem>Women in SHGs use networks like IFFCO Kisan to reach experts and boost sales locally.</ListItem>
            <ListItem>BNI chapters in small towns help entrepreneurs double referrals in a year — now imagine that in your panchayat.</ListItem>
          </ul>
          <p className="mt-3 text-[12px] text-white lg:text-sm">
            Simple networks work wonders for everybody in rural, neighbourhhod areas — just like others.
          </p>
        </Section>

        <Section title="Made Easy for You">
          <ul className="space-y-2 text-[12px] text-white lg:text-sm">
            <ListItem>No tech hassle — clear icons and colors, no jargon.</ListItem>
            <ListItem>Local focus — filter by your area, city, PIN Code, tehsil, join nearby chapters, stay rooted.</ListItem>
            <ListItem>Safe and motivating — track progress visually, share wins.</ListItem>
          </ul>
        </Section>

        <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-violet-600/20 via-fuchsia-600/15 to-rose-500/20 p-6 text-center">
          <h3 className="text-[14px] font-bold text-white lg:text-lg" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Let's build it together
          </h3>
          <p className="mx-auto mt-2 max-w-md text-[12px] leading-relaxed text-white/65 lg:text-sm">
            Start a chapter, share a job, watch your income rise. Join the movement — one
            connection at a time.
          </p>
          <button className={`mt-4 rounded-full px-6 py-2.5 text-[12px] lg:text-sm font-semibold ${ui.gradientBtn}`}>
            Get Involved Today
          </button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, icon, children }) {
  return (
    <section>
      <h3 className="mb-2.5 flex items-center gap-2 text-[13px] lg:text-lg font-bold text-cyan-200" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
        {icon && <FontAwesomeIcon icon={icon} className="text-fuchsia-300 text-[13px]" />}
        {title}
      </h3>
      {children}
    </section>
  );
}

function ListItem({ children }) {
  return (
    <li className="flex gap-2 text-gray-200">
      <FontAwesomeIcon icon={faCircleCheck} className="mt-0.5 shrink-0 text-[11px] text-emerald-300/80" />
      <span>{children}</span>
    </li>
  );
}
